import React, { Component } from "react";
import "./UploadPreview.scss";
import Translated from "../../components/Translated/Translated";

// taken from https://gist.github.com/hartzis/0b77920380736f98e4f9

export default class UploadPreview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			file: "",
			imagePreviewUrl: ""
		};
		this._handleImageChange = this._handleImageChange.bind(this);
		this._handleSubmit = this._handleSubmit.bind(this);
	}

	_handleSubmit(e) {
		e.preventDefault();
	}

	_handleImageChange(e) {
		e.preventDefault();

		let reader = new FileReader();
		let file = e.target.files[0];

		reader.onloadend = () => {
			this.setState({
				file: file,
				imagePreviewUrl: reader.result
			});
			this.props.saveImage(this.props.stateKey, reader.result);
		};

		reader.readAsDataURL(file);
	}

	render() {
		let { imagePreviewUrl } = this.state;
		imagePreviewUrl = imagePreviewUrl ? imagePreviewUrl : this.props.preview;
		let $imagePreview = null;
		if (imagePreviewUrl) {
			$imagePreview = (
				<div class="upload-preview-wrapper">
					<img src={imagePreviewUrl} alt="" />
				</div>
			);
		}

		return (
			<div>
				{$imagePreview}
				<form onSubmit={this._handleSubmit}>
					<div class="upload-preview-file-wrapper">
						<input type="file" onChange={this._handleImageChange} />
						<div class="upload-preview-title">
							{this.state.file ? (
								this.state.file.name
							) : (
								<Translated
									section="Admin Consultant Settings"
									label="choose_file_label"
								/>
							)}
						</div>
					</div>
				</form>
			</div>
		);
	}
}
